import { FEATURES_FITOSGEST } from 'templates/environment.fitosgest';

export const environment = {
    production: true,
    v: '3.5',
    serverUrl: 'https://netagro.fitosgest.com/',
    logoUrl: 'assets/logo_netagro.png',
    appName: 'netagro',
    features: { ...FEATURES_FITOSGEST }
};